import { render, staticRenderFns } from "./TextareaCounter.vue?vue&type=template&id=2b620ec7&"
import script from "./TextareaCounter.vue?vue&type=script&lang=js&"
export * from "./TextareaCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports